import { CanvasNode, CanvasElementType } from '../canvas-types';

export const isNbNode = (node?: CanvasNode) => node?.type === CanvasElementType.NURTURING_BUCKET;
